import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {validateRefundBank} from '../../services/validateRefundBank';

type UseValidateRefundBankQueryParams = {
	bankCode: string;
	agencyCode: string;
	enabled?: boolean;
};

export function useValidateRefundBankQuery({
	bankCode,
	agencyCode,
	enabled = true,
}: UseValidateRefundBankQueryParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.VALIDATE_REFUND_BANK, bankCode, agencyCode],
		queryFn: async ({signal}) => validateRefundBank({signal, bankCode, agencyCode}),
		enabled: enabled && Boolean(bankCode && agencyCode),
		retry: 2,
	});
}
